import { Select } from '~/components/form/Select/Select'
import { classNames } from '~/utils/client/helpers'
import { useUrlQueries } from '~/utils/client/hooks/useUrlQueries'

export type TableElementsSelectProps = {
  maxElements?: number
  label?: string
  className?: string
}

export const TableElementsSelect = ({
  maxElements,
  label,
  className,
  ...props
}: TableElementsSelectProps) => {
  const { getUrlQuery, setUrlQuery, submitSearchParams } = useUrlQueries()

  const maxCountElements = maxElements
    ? Number(maxElements)
    : getUrlQuery('count')
    ? Number(getUrlQuery('count'))
    : 10

  const handleElementCountChange = (count: string | null) => {
    if (count) {
      setUrlQuery([{ count, page: '0' }])
      submitSearchParams()
    }
  }

  return (
    <Select
      className={classNames('mt-0 z-15 min-w-[5rem]', className)}
      name={'countPerPage'}
      defaultValue={maxCountElements.toString()}
      placeholder={'Anzahl'}
      onChange={handleElementCountChange}
      options={[
        { value: '10', label: '10' },
        { value: '20', label: '20' },
        { value: '50', label: '50' },
        { value: '100', label: '100' },
      ]}
      {...props}
    />
  )
}
